import { useContext } from "react";
import { PaymentContext, PaymentContextType } from "../contexts/payment.context";

export const usePayments = () => {
    return useContext(PaymentContext) as PaymentContextType;
};
